<template>
  <v-dialog
    id="customer-modal-form"
    ref="customerModalForm"
    v-model="$store.state.customerModalFormOpen"
    :disabled="!isPermittedAll(['CustomersGeyByID'])"
    width="950"
    persistent
    no-click-animation>
    <form
      @submit.prevent="saveCustomer">
      <v-container
        class="px-5 pb-2 pt-0">
        <!-- Title -->
        <v-row>
          <v-col
            class="d-flex pr-0">
            <h2>
              <span
                v-if="$store.getters.isActiveCustomerDirty || supportContractEndUtc">
                *
              </span>
              <span
                v-if="activeCustomer.CustomerID">
                Edit
              </span>
              <span
                v-else>
                Add
              </span>
              Customer
              <span
                v-if="activeCustomer.CustomerID">
                #{{activeCustomer.CustomerID}}
                -
                {{activeCustomerCopy.CustomerName}}
                <span
                  class="customer-status-dot mt-3"
                  :class="activeCustomerCopy.CustomerStatusColor.CustomerStatusColorName">
                </span>
              </span>
            </h2>
            <v-btn
              class="square ml-auto"
              type="button"
              text
              @click="closeCustomerModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Title -->

        <v-row
          class="flex-grow-0">
          <v-col :cols="isMobile ? 12 : 8">
            <v-row>
              <v-col>
                <v-text-field
                  id="customer-form-name"
                  name="customerName"
                  v-model="activeCustomer.CustomerName"
                  label="Customer:"
                  :readonly="$store.getters.isLoadingActive"
                  hide-details>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="isMobile ? 12 : 6">
                <Autocomplete
                  id="customer-form-type"
                  label="Customer Type:"
                  v-model="customerType"
                  :items="$store.state.customerTypes"
                  item-value="CustomerTypeID"
                  item-text="CustomerTypeName">
                </Autocomplete>
              </v-col>
              <v-col :cols="isMobile ? 12 : 6">
                <v-text-field
                  id="customer-form-website"
                  name="customerWebsite"
                  v-model="activeCustomer.CustomerWebsite"
                  label="Website:"
                  :readonly="$store.getters.isLoadingActive"
                  hide-details>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row           
              v-if="activeCustomer.CustomerID
                && isPermittedAll([
                  'EmployeesGetAll'
                ])">
              <v-col cols="6">
                <Autocomplete
                  id="customer-form-shipping-contact"
                  label="Supervisor:"
                  v-model="shippingContact"
                  :items="$store.state.customerEmployeesForDropdown"
                  item-value="EmployeeID"
                  item-text="EmployeeName">
                </Autocomplete>
              </v-col>    
            </v-row>
          </v-col>      
          <v-col :cols="isMobile ? 12 : 4">
            <v-row>
              <v-col
                v-if="isPermittedAll([
                  'CustomersSetCustomerIsDealer',
                ])"
                class="d-flex align-center">
                <v-checkbox
                  id="customer-form-customer-is-dealer"
                  label="Customer is a dealer."
                  v-model="activeCustomer.CustomerIsDealer"
                  :readonly="$store.getters.isLoadingActive"
                  :class="isMobile ? 'mt-0' : 'mt-6'">
                </v-checkbox>
                <span
                  class="customer-status-dot blue"
                  :class="isMobile ? '' : 'mt-5'">
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-if="isPermittedAll([
                  'CustomersSetSupportRenewalDeclined',
                ])"
                class="d-flex align-center">
                <v-checkbox
                  id="customer-form-renewal-declined"
                  label="Customer has declined support."
                  v-model="activeCustomer.SupportRenewalDeclined"
                  :readonly="$store.getters.isLoadingActive"
                  :class="isMobile ? 'mt-0' : 'mt-6'">
                </v-checkbox>
                <span
                  class="customer-status-dot red"
                  :class="isMobile ? '' : 'mt-5'">
                </span>
              </v-col>
            </v-row> 
            <v-row>
              <v-col
                v-if="isPermittedAll([
                  'CustomersSetCustomerIsTrial',
                ])"
                class="d-flex align-center">
                <v-checkbox
                  id="customer-form-trial-customer"
                  label="Customer is a trial."
                  v-model="activeCustomer.CustomerIsTrial"
                  :readonly="$store.getters.isLoadingActive"
                  :class="isMobile ? 'mt-0' : 'mt-6'">
                </v-checkbox>
                <span
                  class="customer-status-dot purple"
                  :class="isMobile ? '' : 'mt-5'">
                </span>
              </v-col>
            </v-row>         
          </v-col>
        </v-row>
        <!-- Address Tabs -->
        <v-row>
          <v-col class="pb-0">
            <v-tabs
              v-model="addressTab"
              background-color="transparent"
              centered>
              <v-tab>
                Shipping Address
              </v-tab>
              <v-tab>
                Billing Address
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <!-- / Address Tabs -->

        <!-- Shipping Address Tab Content -->
        <div
          v-if="addressTab === 0">
          <v-row class="d-flex">
            <v-col>
              <v-row justify="end">
                  <v-col
                    :cols="isMobile ? 12 : 8">
                    <v-text-field
                      id="customer-shipping-address1"
                      name="customerShippingAddress1"
                      v-model="activeCustomer.CustomerAddress1"
                      label="Address 1:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-col
                    :cols="isMobile ? 12 : 8">
                    <v-text-field
                      id="customer-shipping-address2"
                      name="customerShippingAddress2"
                      v-model="activeCustomer.CustomerAddress2"
                      label="Address 2:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row :justify="isMobile ? 'start' : 'end'">
                  <v-col
                    :cols="isMobile ? 12 : 4">
                    <v-text-field
                      id="customer-shipping-city"
                      name="customerShippingCity"
                      v-model="activeCustomer.CustomerCity"
                      label="City:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
                  <v-col
                    :cols="isMobile ? 6 : 2">
                    <v-text-field
                      id="customer-shipping-state"
                      name="customerShippingState"
                      v-model="activeCustomer.CustomerState"
                      label="State:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
                  <v-col
                    :cols="isMobile ? 6 : 2">
                    <v-text-field
                      id="customer-shipping-zip"
                      name="customerShippingZip"
                      v-model="activeCustomer.CustomerZipCode"
                      label="Zip:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
                </v-row>
            </v-col> 
            <v-col :cols="isMobile ? 12 : 6">
              <v-row justify="start">
                <v-col
                    :cols="isMobile ? 12 : 8">
                    <v-text-field
                      id="customer-shipping-contact-phone"
                      name="customerShippingContactPhone"
                      v-model="activeCustomer.CustomerPhone1"
                      label="Contact Phone:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
              </v-row>
              <v-row
                justify="start">
                <v-col
                  :cols="isMobile ? 12 : 8">
                  <v-text-field
                    id="customer-shipping-contact-fax"
                    name="customerShippingContactFax"
                    v-model="activeCustomer.CustomerFax"
                    label="Fax:"
                    :readonly="$store.getters.isLoadingActive"
                    hide-details>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col
                  :cols="isMobile ? 12 : 8">
                  <v-text-field
                    id="customer-shipping-contact-email"
                    name="customerShippingContactEmail"
                    v-model="activeCustomer.CustomerEmail"
                    label="Email:"
                    :readonly="$store.getters.isLoadingActive"
                    hide-details>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <!-- / Shipping Address Tab Content -->

        <!-- Billing Address Tab Content -->
         <div
          v-if="addressTab === 1">
          <v-row justify="center">
            <v-col 
                :cols="isMobile ? 8 : 4"
                v-if="activeCustomer.CustomerID
                && isPermittedAll([
                  'EmployeesGetAll'
                ])">
                  <Autocomplete
                    id="customer-billing-contact"
                    label="Contact:"
                    v-model="billingContact"
                    :items="$store.state.customerEmployeesForDropdown"
                    item-value="EmployeeID"
                    item-text="EmployeeName">
                  </Autocomplete>
                </v-col>
                <v-col :cols="isMobile ? 8 : 4">
                  <v-btn
                    class="mt-6"
                    type="button"
                    color="primary"
                    :disabled="$store.getters.isLoadingActive"
                    @click="copyShippingAddress"
                    block>
                    Copy Shipping Address
                  </v-btn>
                </v-col>
          </v-row>
          <v-row class="d-flex">
            <v-col>
              <v-row justify="end">
                  <v-col
                    :cols="isMobile ? 12 : 8">
                    <v-text-field
                      id="customer-billing-address1"
                      name="customerBillingAddress1"
                      v-model="activeCustomer.BillingAddress1"
                      label="Address 1:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-col
                    :cols="isMobile ? 12 : 8">
                    <v-text-field
                      id="customer-billing-address2"
                      name="customerBillingAddress2"
                      v-model="activeCustomer.BillingAddress2"
                      label="Address 2:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row :justify="isMobile ? 'start' : 'end'">
                  <v-col
                    :cols="isMobile ? 12 : 4">
                    <v-text-field
                      id="customer-billing-city"
                      name="customerBillingCity"
                      v-model="activeCustomer.BillingCity"
                      label="City:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
                  <v-col
                    :cols="isMobile ? 6 : 2">
                    <v-text-field
                      id="customer-billing-state"
                      name="customerBillingState"
                      v-model="activeCustomer.BillingState"
                      label="State:"
                      :readonly="$store.getters.isLoadingActive"
                      hide-details>
                    </v-text-field>
                  </v-col>
                  <v-col
                    :cols="isMobile ? 6 : 2">
                    <v-text-field
                    id="customer-billing-zip"
                    name="customerBillingZip"
                    v-model="activeCustomer.BillingZipCode"
                    label="Zip:"
                    :readonly="$store.getters.isLoadingActive"
                    hide-details>
                  </v-text-field>
                  </v-col>
                </v-row>
            </v-col> 
            <v-col :cols="isMobile ? 12 : 6">
              <v-row justify="start">
                <v-col
                    :cols="isMobile ? 12 : 8">
                  <v-text-field
                    id="customer-billing-contact-phone"
                    name="customerBillingContactPhone"
                    :value="activeCustomer.BillingContactEmployee
                      && activeCustomer.BillingContactEmployee.EmployeePhone1"
                    label="Contact Phone:"
                    disabled
                    hide-details>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row
                justify="start">
                <v-col
                  :cols="isMobile ? 12 : 8">
                  <v-text-field
                    id="customer-billing-contact-fax"
                    name="customerBillingContactFax"
                    :value="activeCustomer.BillingContactEmployee
                      && activeCustomer.BillingContactEmployee.EmployeeFax"
                    label="Fax:"
                    disabled
                    hide-details>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row justify="start">
                <v-col
                  :cols="isMobile ? 12 : 8">
                  <v-text-field
                    id="customer-billing-contact-email"
                    name="customerBillingContactEmail"
                    :value="activeCustomer.BillingContactEmployee
                      && activeCustomer.BillingContactEmployee.EmployeeEmail"
                    label="Email:"
                    disabled
                    hide-details>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <!-- / Billing Address Tab Content -->

        <!-- Notes -->
        <v-row>
          <v-col>
            <label
              for="customer-notes">
              Notes:
            </label>
            <v-textarea
              id="customer-notes"
              name="customerNotes"
              class="pt-0 mt-0"
              rows="2"
              v-model="activeCustomer.CustomerNotes"
              :readonly="$store.getters.isLoadingActive"
              hide-details
              no-resize>
            </v-textarea>
          </v-col>
        </v-row>
        <!-- / Notes -->

        <!-- Computers -->
        <v-row
          v-if="activeCustomer.CustomerID
            && isPermittedAll([
              'ComputersGetAll'
            ])">
          <v-col>
            <CustomerComputersFormTable
              :customer-id="activeCustomer.CustomerID"
            />
          </v-col>
        </v-row>
        <!-- / Computers -->

        <!-- Support Date / Update Support -->
        <v-row
          v-if="activeCustomer.CustomerID &&
            isPermittedAll([
              'SupportContractsUpdate'
            ])">
          <v-col cols="6">
            <DatePicker
              input-id="computer-support-date"
              v-model="supportContractEndUtc"
              label="Support End Date:"
              :line-bottom="true"
              :readonly="$store.getters.isLoadingActive"
            />
            <small
              class="error--text font-weight-bold">
              This will update all computers for this customer.
            </small>
          </v-col>
          <v-col
            cols="auto">
            <v-btn
              class="mt-6"
              type="button"
              color="primary"
              :disabled="$store.getters.isLoadingActive
                || !supportContractEndUtc"
              @click="updateSupport">
              Update Support
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Support Date / Update Support -->

        <!-- Buttons -->
        <v-row>
          <v-col
            class="d-flex align-center">
            <LastModifiedBy
              :entity="activeCustomer"
            />

            <v-btn
              v-if="isPermittedToSave"
              class="ml-auto"
              type="submit"
              color="primary"
              :disabled="$store.getters.isLoadingActive
                || !$store.getters.isActiveCustomerDirty">
              Save
            </v-btn>

            <v-btn
              v-if="activeCustomer.CustomerID
                && isPermittedAll([
                  'CustomersDelete',
                ])
                && !activeCustomer.CustomerIsDeleted"
              type="button"
              color="error"
              class="order-first mr-5"
              outlined
              @click="hideCustomer"
              :disabled="$store.getters.isLoadingActive">
              Hide Customer
            </v-btn>

            <v-btn
              v-if="activeCustomer.CustomerID
                && isPermittedAll([
                  'CustomersRestore',
                ])
                && activeCustomer.CustomerIsDeleted"
              type="button"
              color="error"
              class="order-first mr-5"
              outlined
              @click="restoreCustomer"
              :disabled="$store.getters.isLoadingActive">
              Unhide Customer
            </v-btn>
          </v-col>
        </v-row>
        <!-- / Buttons -->
      </v-container>
    </form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import CustomerComputersFormTable from './CustomerComputersFormTable.vue';
import DatePicker from './DatePicker.vue';
import LastModifiedBy from './LastModifiedBy.vue';

export default {
  name: 'CustomerModalForm',
  components: {
    CustomerComputersFormTable,
    DatePicker,
    LastModifiedBy,
  },
  data() {
    return {
      addressTab: 0,
      supportContractEndUtc: undefined,
    };
  },
  computed: {
    isPermittedToSave() {
      return (!this.activeCustomer.CustomerID
          && this.isPermittedAll(['CustomersCreate']))
        || (this.activeCustomer.CustomerID
          && this.isPermittedAll(['CustomersUpdate']));
    },
    activeCustomer() {
      return this.$store.state.activeCustomer;
    },
    activeCustomerCopy() {
      return this.$store.state.activeCustomerCopy;
    },
    customerModalFormOpen() {
      return this.$store.state.customerModalFormOpen;
    },
    customerType: {
      get() {
        return this.activeCustomer.CustomerType;
      },
      set(customerType) {
        if (customerType) {
          this.activeCustomer.CustomerType = _.cloneDeep(customerType);
          this.activeCustomer.CustomerTypeID = customerType.CustomerTypeID;
        }
      },
    },
    shippingContact: {
      get() {
        return this.activeCustomer.SupervisorEmployee;
      },
      set(shippingContact) {
        if (shippingContact) {
          this.activeCustomer.SupervisorEmployee = _.cloneDeep(shippingContact);
          this.activeCustomer.SupervisorEmployeeID = shippingContact.EmployeeID;
        }
      },
    },
    billingContact: {
      get() {
        return this.activeCustomer.BillingContactEmployee;
      },
      set(billingContact) {
        if (billingContact) {
          this.activeCustomer.BillingContactEmployee = _.cloneDeep(billingContact);
          this.activeCustomer.BillingContactEmployeeID = billingContact.EmployeeID;
        }
      },
    },
    customerEmployees() {
      return this.$store.state.customerEmployees;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    '$store.state.customerModalFormOpen': function (open) {
      if (open) {
        this.refreshData();
      }
    },
  },
  methods: {
    closeCustomerModal(skipDirtyCheck) {
      const confirm = () => {
        this.$store.commit('setCustomerModalFormOpen', false);
        setTimeout(() => {
          this.$store.commit('setActiveCustomer');
          this.supportContractEndUtc = undefined;
        }, 200);
      };

      const isDirty = this.$store.getters.isActiveCustomerDirty
        || this.supportContractEndUtc;

      if (isDirty && !skipDirtyCheck) {
        this.showConfirm(
          'Are you sure you want to leave this customer without saving?',
          'You have unsaved changes',
        ).then(confirm, _.noop);
      } else {
        confirm();
      }
    },
    saveCustomer() {
      let promise = Promise.resolve();

      if (this.activeCustomer.CustomerID) {
        promise = this.$store.dispatch('updateCustomer');
      } else {
        promise = this.$store.dispatch('createCustomer');
      }

      promise
        .then(() => this.closeCustomerModal(true));
    },
    hideCustomer() {
      const confirm = () => {
        this.$store.dispatch('deleteCustomer')
          .then(() => {
            this.closeCustomerModal(true);
          });
      };

      this.showConfirm(
        'Are you sure you want to hide this customer?',
        'Hide Customer',
      ).then(confirm, _.noop);
    },
    restoreCustomer() {
      const confirm = () => {
        this.$store.dispatch('restoreCustomer')
          .then(() => {
            this.closeCustomerModal(true);
          });
      };

      this.showConfirm(
        'Are you sure you want to unhide this customer?',
        'Hide Customer',
      ).then(confirm, _.noop);
    },
    copyShippingAddress() {
      this.activeCustomer.BillingAddress1 = this.activeCustomer.CustomerAddress1;
      this.activeCustomer.BillingAddress2 = this.activeCustomer.CustomerAddress2;
      this.activeCustomer.BillingCity = this.activeCustomer.CustomerCity;
      this.activeCustomer.BillingState = this.activeCustomer.CustomerState;
      this.activeCustomer.BillingZipCode = this.activeCustomer.CustomerZipCode;
    },
    updateSupport() {
      this.$store.dispatch(
        'updateAllSupportContracts',
        {
          supportContractEndUtc: this.supportContractEndUtc,
        },
      ).then(() => {
        this.supportContractEndUtc = undefined;
      });
    },
    refreshData() {
      this.$store.dispatch('getCustomerTypes');
      this.$store.dispatch('getCustomerEmployeesForDropdown', {
        params: {
          CustomerID: this.activeCustomer.CustomerID,
        },
      });
    },
  },
};
</script>

<style lang="scss"></style>
